import { doLogout } from "actions/authAction";

import {
  BASE_URL,
  LIST_SHIPPER_GET_ERROR,
  LIST_SHIPPER_GET_LOADING,
  LIST_SHIPPER_GET_SUCCESS,
  TYPECONTAINER_GET_ERROR,
  TYPECONTAINER_GET_LOADING,
  TYPECONTAINER_GET_SUCCESS,
  TYPECONTAINER_URL,
} from "./constant";

export const SEARCH_SIMULASI_TARIF_LOADING = "SEARCH_SIMULASI_TARIF_LOADING";
export const SEARCH_SIMULASI_TARIF_SUCCESS = "SEARCH_SIMULASI_TARIF_SUCCESS";
export const SEARCH_SIMULASI_TARIF_ERROR = "SEARCH_SIMULASI_TARIF_ERROR";

const searchSimulasiTarifLoading = (bool) => {
  return {
    type: SEARCH_SIMULASI_TARIF_LOADING,
    searchSimulasiTarifLoading: bool,
  };
};

const searchSimulasiTarifSuccess = (bool, simulasiTarif) => {
  return {
    type: SEARCH_SIMULASI_TARIF_SUCCESS,
    searchSimulasiTarifSuccess: bool,
    simulasiTarif,
  };
};

const searchSimulasiTarifError = (bool) => {
  return {
    type: SEARCH_SIMULASI_TARIF_ERROR,
    searchSimulasiTarifError: bool,
  };
};

const listShipperGetError = (bool) => {
  return {
    type: LIST_SHIPPER_GET_ERROR,
    listShipperGetError: bool,
  };
};

const listShipperGetLoading = (bool) => {
  return {
    type: LIST_SHIPPER_GET_LOADING,
    listShipperGetLoading: bool,
  };
};

export const listShipperGetSuccess = (bool, listShipper) => {
  return {
    type: LIST_SHIPPER_GET_SUCCESS,
    listShipperGetSuccess: bool,
    listShipper,
  };
};

const typecontainerGetError = (bool) => {
  return {
    type: TYPECONTAINER_GET_ERROR,
    typecontainerGetError: bool,
  };
};

const typecontainerGetLoading = (bool) => {
  return {
    type: TYPECONTAINER_GET_LOADING,
    typecontainerGetLoading: bool,
  };
};

const typecontainerGetSuccess = (bool, typecontainers) => {
  return {
    type: TYPECONTAINER_GET_SUCCESS,
    typecontainerGetSuccess: bool,
    typecontainers,
  };
};

export function searchSimulasiTarifNew(data) {
  return (dispatch) => {
    dispatch(searchSimulasiTarifLoading(true));
    dispatch(searchSimulasiTarifSuccess(false, []));
    dispatch(searchSimulasiTarifError(false));

    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + "portal/simulasi_tarif", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(searchSimulasiTarifLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(searchSimulasiTarifSuccess(true, data));
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(searchSimulasiTarifError(true));
      });
  };
}

export function listShipperFetchSub(idOrigin, idDestination) {
  return (dispatch) => {
    dispatch(listShipperGetSuccess(false, null));
    dispatch(listShipperGetError(false));
    dispatch(listShipperGetLoading(true));
    // let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    config = {
      method: "POST",
      headers: {
        // Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    fetch(
      BASE_URL +
        "portal/simulasi_tarif/list-shipper?" +
        `port_origin_id=${idOrigin}&port_destination_id=${idDestination}`,
      config
    )
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(listShipperGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(listShipperGetSuccess(true, data));
        }
      })
      .catch((err) => {
        dispatch(listShipperGetError(true));
      });
  };
}

export function typeContainerPortal(data) {
  return (dispatch) => {
    dispatch(typecontainerGetSuccess(false, null));
    dispatch(typecontainerGetError(false));
    dispatch(typecontainerGetLoading(true));

    // let token = localStorage.getItem('tolaut@token') || null
    let config = {};
    config = {
      method: "POST",
      headers: {
        // 'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + TYPECONTAINER_URL + "/portal", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(typecontainerGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(typecontainerGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(typecontainerGetError(true));
      });
  };
}
